import React, { useState, useEffect } from "react";
import { API_URL, getValFromLS } from "../helpers";

const Div = ({ status, text }) => {
	let classes = "";
	if (status === 0) {
		classes = "fa fa-times fa-lg error";
	} else if (status === 1) {
		classes = "fa fa-check fa-lg success";
	} else if (status === 2) {
		classes = "fa fa-circle-o-notch fa-spin fa-lg working";
	}

	return (
		<div>
			<div className="i-container">
				<i className={classes} />
			</div>
			<span className={status === 3 ? "working" : ""}>{text}</span>
		</div>
	);
};

const Uploaded = ({ records, uploadedFileName, msg }) => {
	const [status, setStatus] = useState({
		1: 1,
		2: 3,
		3: 3,
		4: 3,
		5: 3,
		6: 3,
		7: 3,
		8: 3,
	});

	/* Status
    0 - Error
    1 - Success
    2 - Working
    3 - Idle
  */

	/*
    Step 1 - Uploaded .csv
    Step 2 - Checking donationId fields
    Step 3 - Checking charityCode codes
    Step 4 - Checking donation amounts
    Step 5 - Checking attributions & tax receipt
    Step 6 - Checking email syntaxes
    Step 7 - Checking date syntaxes
    Step 8 - Parsing records to donation records
  */

	useEffect(() => {
		const init = async () => {
			handleBatch(2);
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleBatch = async (num) => {
		setStatus((status) => ({ ...status, [num]: 2 }));

		const url = new URL(`${API_URL}/auth/batch${num}`);
		let data = new FormData();
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				if (num === 8) {
					setStatus((status) => ({ ...status, [num]: 1 }));
					msg({
						type: "success",
						text: json.text,
					});
				} else {
					const nextNum = num + 1;
					setStatus((status) => ({ ...status, [num]: 1 }));
					handleBatch(nextNum);
				}
			} else {
				setStatus((status) => ({ ...status, [num]: 0 }));
				msg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setStatus((status) => ({ ...status, [num]: 0 }));
			msg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div className="uploaded-container">
			<Div
				status={status["1"]}
				text={`1 - ${uploadedFileName} Uploaded (${records} records)`}
			/>
			<Div status={status["2"]} text="2 - Checking Donation IDs" />
			<Div status={status["3"]} text="3 - Checking Charity Codes" />
			<Div status={status["4"]} text="4 - Checking Donation Amounts" />
			<Div
				status={status["5"]}
				text="5 - Checking Attributions & Tax Receipt"
			/>
			<Div status={status["6"]} text="6 - Checking Emails Syntax" />
			<Div status={status["7"]} text="7 - Checking Dates Syntax" />
			<Div status={status["8"]} text="8 - Processing Batch Donations" />
		</div>
	);
};

export default Uploaded;
